module.exports = __webpack_public_path__ + "static/media/mu.f912245c.svg";